<template>
  <StandaloneLayout>
    <v-icon color="error" size="120">mdi-alert-circle-outline</v-icon>
    <h1 class="mt-6">404 - Page Not Found</h1>
    <p class="mb-6">Sorry, the page you requested does not exist.</p>
    <v-btn color="primary" prepend-icon="mdi-home" to="/"> Go Home </v-btn>
  </StandaloneLayout>
</template>

<script setup>
  import { StandaloneLayout } from '#xapp-core/shell'
</script>
